export const userSearchFieldOptions = [
  { id: 'name', name: 'Nome' },
  { id: 'registration', name: 'Matrícula' },
];
